import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  getUniqueIdentifier,
  handleError,
  HttpRequestMethods
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable } from 'rxjs';

import { TRIP_USING } from '@com-delta-idp/mnx-capability-trip-management-ui';
import { IDP_APP } from '../constants/my-trip-constants';
import {
  HTTP_HEADERS,
  MyTripEndpointKeys
} from '../models/enums/my-trip.enums';
import {
  CreditRequest,
  TravelReservation,
  TripsRequest
} from '../models/interface';

@Injectable({
  providedIn: 'root'
})
export class CreditCardSearchService {
  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  errorHandler = handleError.bind(this);

  getPNRList = (request: CreditRequest): Observable<TravelReservation> => {
    return new ApiBuilder<TripsRequest, TravelReservation>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(MyTripEndpointKeys.TRAVEL_RESERVATION)
      .method(HttpRequestMethods.POST)
      .payload({
        using: TRIP_USING.CREDITCARD,
        creditCardNum: request.referenceId,
        givenNames: request.fName,
        surname: request.lName
      })
      .httpHeaders({
        'Content-Type': HTTP_HEADERS.CONTENT_TYPE,
        appId: HTTP_HEADERS.APP_ID,
        channelId: HTTP_HEADERS.MY_TRIP,
        transactionid: `${HTTP_HEADERS.TRANSACTION_ID_PREFIX}-${
          request.app
        }-${getUniqueIdentifier()}`
      })
      .errorHandler(this.errorHandler)
      .create();
  };
}
